module.exports = __webpack_public_path__ + "static/og-image-c34489030a92bfc26f7e44830aaf5b48.jpg";